// Copyright (c) 2016 Deere & Company

import Criteria, {getDefaultState} from '../../settlement-no-registration/state/criteria';
import actions from '../../actions-list';

const updateHistoryToDisplayCriteria = (state, action) =>
    Criteria.update(state, {
        historyToDisplay: {
            $set: action.historyToDisplay
        }
    });

const resetHistoryToDisplayCriteria = state =>
    Criteria.update(state, {
        historyToDisplay: {
            $set: null
        }
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.UPDATE_SETTLEMENT_NO_REGISTRATION_HISTORY_TO_DISPLAY_CRITERIA]: updateHistoryToDisplayCriteria,
        [actions.RESET_SETTLEMENT_NO_REGISTRATION_HISTORY_TO_DISPLAY_CRITERIA]: resetHistoryToDisplayCriteria
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/settlement-no-registration/reducers/criteria.js